import { authenticate } from '@cian/auth/lib/authenticator';
import { IContractRentSaleResponse } from '../../store/contract_rent_sale';
import { IMakeRequest } from '../../utils/make_request';

import { filterServerResponse } from '../helpers';
import { TURIScheme } from '@cian/http-api/shared/uri';
import { IHTTPCompletedResponse } from '@cian/http-api/shared';

export function subscriptionContractRentSale(
  makeRequest: IMakeRequest,
  host: string,
  email: string,
  docType: string,
  subscribeNews: boolean,
): Promise<{}> {
  return makeRequest({
    body: JSON.stringify({
      docType,
      email,
      subscribeNews,
    }),
    headers: [['Content-Type', 'application/json']],
    method: 'POST',
    uri: {
      host,
      path: `/cian-api/site/v1/subscription-send-contract/`,
      scheme: document.location.protocol.slice(0, -1) as TURIScheme,
    },
  })
    .then(filterServerResponse)
    .then((response: IHTTPCompletedResponse): Promise<IContractRentSaleResponse> | IContractRentSaleResponse => {
      const body = JSON.parse(response.responseBody);
      const logonInfo = body.data && body.data.logOnInfo;
      const login = body.data && body.data.login;
      const subscribe = response && response.responseStatusCode === 204;

      if (logonInfo && login) {
        return authenticate(logonInfo, login, true).then(
          (): IContractRentSaleResponse => {
            return {
              auth: true,
              subscribe,
              user: {
                email: login,
                isAuthenticated: true,
                cianName: null,
                cianUserId: null,
                companyName: '',
                criteoEmail: null,
                firstName: null,
                ga: null,
                isAgent: null,
                lastName: null,
                permissions: null,
                phones: null,
                realtyUserId: null,
              },
            };
          },
        );
      } else {
        return {
          auth: false,
          subscribe,
        };
      }
    });
}
